import NeighborhoodPageContent from "../NeighborhoodPageContent";

export default function CruzDeHumilladero() {
  return <NeighborhoodPageContent slug="cruz-de-humilladero" />;
}